import {
  LetterbooksSeriesConditionType,
} from "features/Letterbooks/types";
import LetterbooksParentContextType, { LetterbooksParentSeriesContextType } from "types/LetterbooksParentContextType";

export default function seriesConditions(
  context: LetterbooksParentContextType
): LetterbooksSeriesConditionType {
  const { series } = (context as unknown as LetterbooksParentSeriesContextType);

  return {
    series_id: series.id
  };
}
